// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { XngStickyWrapper } from "@sc/App/Components/XngSticky/XngSticky";
import { myAccountDetailsPagesLayout } from "@sc/App/Widgets/Layout/MyAccountDetailsPagesLayout";
import { xScreen } from "@sc/XDL/Utilities";
import { css } from "styled-components";

myAccountDetailsPagesLayout.container = {
    css: css`
        display: flex;
        flex-direction: column;
        @media print {
            display: block;
        }
    `,
};

myAccountDetailsPagesLayout.informationContainer = {
    css: css`
        display: flex;
        gap: 25px;
        ${xScreen("lt", "sm")} {
            flex-direction: column;
        }
        @media print {
            display: block;
        }
    `,
};
myAccountDetailsPagesLayout.information = {
    css: css`
        display: flex;
        flex-direction: column;
        @media print {
            display: block;
            h2 {
                font-size: 15px;
            }
        }
        ${xScreen("lt", "sm")} {
            flex: 1 1 100%;
            width: 100%;
        }
    `,
};
myAccountDetailsPagesLayout.productList = {
    css: css`
        display: flex;
        flex-direction: column;
        width: 100%;
        @media print {
            display: block;
        }
    `,
};
myAccountDetailsPagesLayout.total = {
    css: css`
        flex: 0 0 319px;
        &,
        & ${XngStickyWrapper} {
            display: flex;
            flex-direction: column;
            gap: 16px;
        }
        @media print {
            display: block;
            margin-top: 25px;
            max-width: 450px;
        }
        ${xScreen("lte", "md")} {
            flex-basis: 234px;
        }
        ${xScreen("lt", "sm")} {
            flex-basis: 100%;
            max-width: 450px;
        }
        ${xScreen("lt", "xs")} {
            max-width: 100%;
        }
    `,
};
myAccountDetailsPagesLayout.productLisContainer = {
    css: css`
        &:empty,
        &:has(> div:empty) {
            display: none;
        }
        @media print {
            display: block;
        }
    `,
};
myAccountDetailsPagesLayout.xngStickyStyles = {
    css: css`
        ${xScreen("lte", "sm")} {
            width: 100%;
        }
        @media print {
            width: 100%;
        }
        &> div: empty {
            display: none;
        }
    `,
};
myAccountDetailsPagesLayout.spinnerWrapper = {
    css: css`
        display: flex;
        justify-content: center;
        align-items: center;
        height: 300px;
    `,
};

myAccountDetailsPagesLayout.details = {
    css: css`
        display: flex;
        column-gap: 22px;
        ${xScreen("lt", "md")} {
            flex-direction: column;
        }
        @media print {
            display: block;
        }
    `,
};

myAccountDetailsPagesLayout.detailsLeftColumn = {
    css: css`
        display: flex;
        flex-direction: column;
        flex: 1;
        ${xScreen("gte", "lg")} {
            & > div {
                margin-bottom: 20px;
                &:empty {
                    display: none;
                }
                @media print {
                    margin-bottom: 0;
                }
            }
        }
    `,
};

myAccountDetailsPagesLayout.detailsRightColumn = {
    css: css`
        display: flex;
        flex-direction: column;
        flex: 1;
        & > div {
            margin-bottom: 20px;
            &:empty {
                display: none;
            }
        }
    `,
};
